import Icon from 'components/atoms/Icon';
import { MAINTENANCE_MODE_WARNING_STORAGE_KEY } from 'constants/maintenance';
import SystemBanner from 'components/features/connectionQuality/SystemBanner';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MaintenanceModeWarningBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(
    sessionStorage.getItem(MAINTENANCE_MODE_WARNING_STORAGE_KEY) === 'true'
  );

  const handleDismiss = () => {
    sessionStorage.setItem(MAINTENANCE_MODE_WARNING_STORAGE_KEY, 'true');
    setIsVisible(false);
    setTimeout(() => {
      setIsDismissed(true);
    }, 300);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <SystemBanner
      icon={<Icon icon="warning" />}
      color="warning"
      visible={isVisible}
      dismissable
      content={
        <>
          <span style={{ fontWeight: 600 }}>{t('maintenance.scheduledMaintenance')}</span> {t('maintenance.description')}
        </>
      }
      onDismiss={handleDismiss}
    />
  );
};

export default MaintenanceModeWarningBanner;
